export type CraPresentationVariant = "legacy" | "zuu";

export function resolveCraPresentationVariant(input: {
  brandId?: string | null;
  tenantCode?: string | null;
}): CraPresentationVariant {
  if (input.brandId === "zuu" || input.tenantCode === "zuu") {
    return "zuu";
  }

  return "legacy";
}

export function isZuuCraVariant(input: {
  brandId?: string | null;
  tenantCode?: string | null;
}): boolean {
  return resolveCraPresentationVariant(input) === "zuu";
}
